import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ThemeWrapper from './components/ThemeWrapper';
import HeroSection from './components/HeroSection';
import HiraganaCharactersPage from './components/HiraganaCharactersPage';
import { LearnPage } from './components/learn'; 
import Quiz from './components/Quiz';
import Whiteboard from './components/Whiteboard';
import Videos from './components/Videos';
import Hiragana101 from './components/Hiragana101';
import Katakana101 from './components/Katakana101';
import Kanji101 from './components/Kanji101';
import CharacterTracingPage from './components/CharacterTracingPage';
import Conversation from './components/Conversation';

const App = () => (
  <ThemeWrapper>
    <Router>
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/hiragana" element={<HiraganaCharactersPage />} />
        <Route path="/learn" element={<LearnPage />} />
        <Route path="/whiteboard" element={<Whiteboard />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/hiragana101" element={<Hiragana101 />} />
        <Route path="/katakana101" element={<Katakana101 />} />
        <Route path="/kanji101" element={<Kanji101 />} />
        <Route path="/trace-characters/:scriptType" element={<CharacterTracingPage />} />
        <Route path="/chapter/:chapterId" element={<Quiz />} />
        <Route path="/conversation" element={<Conversation />} />
      </Routes>
    </Router>
  </ThemeWrapper>
);

export default App;